import type { IScope, ITimeoutService } from "angular";
import { isDefined } from "angular";
import "@progress/kendo-ui/js/kendo.slider";

export class SliderComponentController {
    public static $inject: string[] = ["$scope", "$timeout", "debounce", "resize"];

    public static readonly defaultOptions = {
        largeStep: 10,
        max: 90,
        min: 0,
        smallStep: 1,
    };

    public kendoSlider: kendo.ui.Slider;

    public ngModel: number;

    public inputId: string;

    public min: number;

    public max: number;

    public smallStep: number;

    public largeStep: number;

    public recalculate: string;

    public tooltip: any;

    public internalValue: number;

    private debouncedSlide: (value: number) => void;

    constructor(
        private readonly $scope: IScope,
        private readonly $timeout: ITimeoutService,
        private readonly debounce: any,
        private readonly resize: any,
    ) {}

    public $onInit() {
        this.internalValue = this.ngModel;

        if (!isDefined(this.max)) {
            this.max = SliderComponentController.defaultOptions.max;
        }
        if (!isDefined(this.min)) {
            this.min = SliderComponentController.defaultOptions.min;
        }
        if (!isDefined(this.smallStep)) {
            this.smallStep = SliderComponentController.defaultOptions.smallStep;
        }
        if (!isDefined(this.largeStep)) {
            this.largeStep = SliderComponentController.defaultOptions.largeStep;
        }
        if (!isDefined(this.tooltip)) {
            this.tooltip = { enabled: true };
        }

        this.debouncedSlide = this.debounce(
            100,
            (value: number) => {
                this.ngModel = value;
            },
            true,
        );

        this.resize(this.$scope).call(() => {
            this.kendoSlider.resize();
        });

        this.$scope.$on("slider.resize", () => {
            this.$timeout(() => this.kendoSlider.resize());
            this.$timeout(() => this.kendoSlider.resize(), 500);
        });

        this.$scope.$watch("$ctrl.ngModel", () => {
            this.internalValue = this.ngModel;
        });

        this.$scope.$watchGroup(
            ["$ctrl.min", "$ctrl.max", "$ctrl.smallStep", "$ctrl.largeStep"],
            ([min, max, smallStep, largeStep]) => {
                const options = {
                    largeStep: largeStep || SliderComponentController.defaultOptions.largeStep,
                    max: max || SliderComponentController.defaultOptions.max,
                    min: min || SliderComponentController.defaultOptions.min,
                    smallStep: smallStep || SliderComponentController.defaultOptions.smallStep,
                };
                this.kendoSlider.setOptions(options);
            },
        );

        this.$timeout(() => this.kendoSlider.resize(), 500);
    }

    public onSlide(kendoEvent: kendo.ui.SliderSlideEvent) {
        this.debouncedSlide(kendoEvent.value);
    }
}
